module.exports = __webpack_public_path__ + "static/img/software33.0f52c3dd.png";